export default __webpack_public_path__ + "static/media/bubble-06.ba3df339.png";